// Mock data for Dr. M D Samudri Portfolio

export const profileData = {
  name: "Dr. M D Samudri",
  fullName: "Dr. Samudri Mahamad Asraf Dastageerasab",
  designation: "Principal",
  institution: "TMAE Society Ayurvedic Medical College, PG Research Centre & SCS Hospital, Vijayanagara, Karnataka, India",
  previousDesignation: "Professor & HOD of Shalya Tantra",
  previousInstitution: "D.G.M. Ayurvedic Medical College Hospital & Research Centre, Gadag",
  qualification: "MS (Ayu), CYS",
  experience: "15+ Years",
  email: "dsamudri@gmail.com",
  phone: "+919964187315",
  motto: "Learn to Serve",
  tagline: "Ayurvedic Surgeon | Researcher | Humanitarian",
  photo: "/dr-samudri.png",
  about: "Arguably one of the best doctors a patient seeks. Highly competent in diagnosis and in dispensing treatment. His empathetic approach towards patients is appealing. A strong work ethic, accentuated with true passion for work. With an encyclopedic amount of knowledge and dynamism, he leads and trains young, aspiring doctors.",
  mission: "I shall be committed for the up-liftment of the society and nation. I would work sincerely to fulfil the lacunae nevertheless maintaining the dignity, discipline and integrity.",
  vision: "Standardisation of procedures and making use of these by consignment with multinational companies is my objective. So that each and every citizen of country is benefitted by the service."
};

export const stats = [
  { value: "15+", label: "Years Experience" },
  { value: "287", label: "Research Papers" },
  { value: "50+", label: "Awards & Honors" },
  { value: "10K+", label: "Patients Treated" }
];

export const expertise = [
  {
    id: 1,
    title: "Kshara Karma in Tundikeri",
    description: "Pioneering invention of a new surgical technique for tonsillitis treatment",
    icon: "Syringe"
  },
  {
    id: 2,
    title: "Nanotechnology & Polymers",
    description: "Groundbreaking research integrating modern science with Ayurveda",
    icon: "Microscope"
  },
  {
    id: 3,
    title: "Anorectal Disorders",
    description: "Specialized treatment for chronic anorectal conditions with Ayurvedic approach",
    icon: "Stethoscope"
  },
  {
    id: 4,
    title: "Chronic Disease Management",
    description: "Expert treatment for Ulcerative Colitis, Sciatica, Rheumatoid Arthritis",
    icon: "Heart"
  },
  {
    id: 5,
    title: "Surgical Training",
    description: "Hand-to-hand surgical training for aspiring Ayurvedic surgeons",
    icon: "Users"
  },
  {
    id: 6,
    title: "Disaster Management",
    description: "Leading medical relief operations during natural calamities",
    icon: "Shield"
  }
];

export const timeline = [
  {
    year: "Present",
    title: "Principal",
    organization: "TMAE Society Ayurvedic Medical College, PG Research Centre & SCS Hospital, Vijayanagara",
    description: "Leading the institution with vision for excellence in Ayurvedic education and research"
  },
  {
    year: "2020-Present",
    title: "District Hon'ble Secretary",
    organization: "Indian Red Cross Society, Gadag",
    description: "Leading humanitarian efforts, flood relief, COVID-19 response"
  },
  {
    year: "2017-2024",
    title: "Professor & Head of Department",
    organization: "Dept. of Shalya Tantra, DGM Ayurvedic College, Gadag",
    description: "Led surgical department and trained young doctors in Ayurvedic surgery"
  },
  {
    year: "2016",
    title: "Promoted to Professor",
    organization: "DGM Ayurvedic Medical College, Gadag",
    description: "Recognition of excellence in teaching and research"
  },
  {
    year: "2006",
    title: "Joined as Faculty",
    organization: "DGM Ayurvedic Medical College, Gadag",
    description: "Started academic journey in surgical training"
  },
  {
    year: "2005",
    title: "MS (Ayurveda) in Shalya Tantra",
    organization: "RGUHS University, Bengaluru",
    description: "Completed post-graduation in Ayurvedic Surgery"
  },
  {
    year: "1999",
    title: "B.A.M.S. Degree",
    organization: "Karnataka University, Dharawad",
    description: "Bachelor of Ayurvedic Medicine and Surgery (58.3%)"
  }
];

export const awards = [
  {
    year: "2019",
    title: "Sushrut Ratna",
    organization: "National Recognition",
    description: "Excellence in Ayurvedic Surgery"
  },
  {
    year: "2018-19",
    title: "Rejoice National AYUSH Award",
    organization: "AYUSH Minister",
    description: "Outstanding contribution to Ayurveda"
  },
  {
    year: "2013-14",
    title: "Ashwini Award",
    organization: "SDMAM College, Hassan",
    description: "Recognition for surgical expertise"
  },
  {
    year: "2009",
    title: "International Excellence Award",
    organization: "Bangkok, Thailand",
    description: "Global recognition for Ayurvedic contributions"
  },
  {
    year: "2008",
    title: "Sushruta Vibhushan",
    organization: "International Academy of Ayurvedic Physicians",
    description: "Prestigious honor in Ayurvedic medicine"
  }
];

export const publications = [
  {
    year: "2019",
    title: "Conceptual Understanding of Emergency Medicine in Ayurveda",
    journal: "Monograph by Physicians Association of India",
    category: "Research"
  },
  {
    year: "2018",
    title: "Role of Avapeedana Nasya in Pakshaghata",
    journal: "Ayushdhara",
    category: "Clinical"
  },
  {
    year: "2009",
    title: "Nonsurgical Management of Tundikeri",
    journal: "Ayurveda Holistic Approaches, Bangkok, Thailand",
    category: "International"
  },
  {
    year: "2007",
    title: "Siravedha in Gridrasi Classical Approach",
    journal: "National Seminar on Panchakarma, Maharashtra",
    category: "Research"
  },
  {
    year: "2006",
    title: "Concept of Sandhana Karma",
    journal: "Atharva 2006 Souvenir",
    category: "Theory"
  },
  {
    year: "2004",
    title: "Non Invasive Technique in the Management of Tundikeri",
    journal: "Ayurashmi",
    category: "Clinical"
  }
];

export const conferences = [
  {
    year: "2020",
    title: "Multiple Webinars",
    type: "National",
    role: "Resource Person & Live Surgical Demonstration",
    topics: ["Management of Bhagandara", "Siravedha", "Polymers in Ayurveda"]
  },
  {
    year: "2019",
    title: "Update Proctology-2019 & Sushrut Ratna",
    type: "National",
    role: "Live Surgical Demonstration",
    topics: ["Kshara Karma in Anorectal Disorders"]
  },
  {
    year: "2017",
    title: "Update Proctology-17",
    type: "National",
    role: "Resource Person",
    location: "Malvan, Maharashtra"
  },
  {
    year: "2016",
    title: "Charaka Saptaha",
    type: "International",
    role: "Speaker",
    location: "Kolhapur, Maharashtra"
  },
  {
    year: "2011",
    title: "5th International Conference on Ayurveda",
    type: "International",
    role: "Speaker",
    location: "Singapore"
  },
  {
    year: "2010",
    title: "4th International Conference on Ayurveda",
    type: "International",
    role: "Speaker",
    location: "Dubai, UAE"
  },
  {
    year: "2009",
    title: "3rd International Conference on Ayurveda",
    type: "International",
    role: "Speaker",
    location: "Bangkok, Thailand"
  }
];

export const socialService = [
  {
    title: "COVID-19 Warrior",
    description: "Distribution of masks, sanitizers, soaps, and essentials to corona warriors and needy",
    impact: "10,000+ people served"
  },
  {
    title: "Flood Relief Operations",
    description: "Medical camps in Jammu & Kashmir (2018), Karnataka (2018), Gujarat (2019)",
    impact: "5,000+ flood victims treated"
  },
  {
    title: "Free Medical Camps",
    description: "Regular health check-up camps in rural areas and underserved communities",
    impact: "50+ camps organized"
  },
  {
    title: "Blood Donation Drives",
    description: "Organized blood donation camps across Gadag district",
    impact: "2,000+ units collected"
  },
  {
    title: "First Aid Training",
    description: "Authorized trainer conducting first aid workshops for schools, colleges, and organizations",
    impact: "3,000+ trained"
  },
  {
    title: "Red Cross Society Leadership",
    description: "Received 2 appreciation awards from district administration and IMA Gadag",
    impact: "District-wide impact"
  }
];

export const research = [
  {
    title: "Role of Basti in Mutra krichra with special reference to B.P.H.",
    status: "In Progress"
  },
  {
    title: "Postoperative pain management on Ayurvedic Perspective",
    status: "In Progress"
  },
  {
    title: "Management of Pakshaghata with special reference to Mada and Murcha",
    status: "In Progress"
  },
  {
    title: "Nano technology in Safe drinking water (Co-laboratory with IIT)",
    status: "Under Process"
  },
  {
    title: "Management of Ulcerative colitis with special reference to Anukta Basti",
    status: "In Progress"
  }
];

export const gallery = [
  {
    id: 1,
    title: "Live Surgical Demonstration",
    category: "surgery",
    description: "Training session at national workshop"
  },
  {
    id: 2,
    title: "International Conference - Bangkok",
    category: "conference",
    description: "Presenting research at international forum"
  },
  {
    id: 3,
    title: "Flood Relief Camp - Kashmir",
    category: "relief",
    description: "Medical service for flood-affected people"
  },
  {
    id: 4,
    title: "COVID-19 Relief Work",
    category: "relief",
    description: "Distributing essentials to corona warriors"
  },
  {
    id: 5,
    title: "First Aid Training",
    category: "training",
    description: "Conducting first aid workshop for students"
  },
  {
    id: 6,
    title: "Award Ceremony",
    category: "awards",
    description: "Receiving Sushrut Ratna Award 2019"
  }
];